import PropTypes from 'prop-types'
import React from 'react'
import './index.css'

const WarehouseSetupConnectStep = props => (
  <div className='WarehouseSetupConnectStep'>
    <header>
      <h4 className='WarehouseSetupConnectStep-title'>Step {props.number}: {props.title}</h4>
    </header>
    <div className='WarehouseSetupConnectStep-content'>
      {props.children}
    </div>
  </div>
)

WarehouseSetupConnectStep.displayName = 'WarehouseSetupConnectStep'

WarehouseSetupConnectStep.propTypes = {
  children: PropTypes.array.isRequired,
  number: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default WarehouseSetupConnectStep



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/warehouse-setup-connect-step/index.js